

























import Vue from 'vue';
import { mapActions } from 'vuex';

import FloatingBackground from '@/components/ui/background/floating-background.vue';
import SamplesDialog from '@/components/ui/dialogs/samples-dialog/samples-dialog.vue';

export default Vue.extend({
  name: 'Welcome',

  components: {
    SamplesDialog,
    FloatingBackground,
  },

  methods: {
    ...mapActions('data', [
      'loadExampleData',
    ]),

    ...mapActions('auth', [
      'login',
    ]),
  },
});
